import { isAddress } from 'web3-validator';

export const getExplorerLink = (txHashOrAddress: string): string => {
  const sub = isAddress(txHashOrAddress) ? 'address/' : 'tx/';
  const scan =
    import.meta.env.VITE_USE_CHAIN === 'polygon'
      ? import.meta.env.VITE_MATIC_SCAN
      : import.meta.env.VITE_SEPOLIA_SCAN;
  return `${scan}${sub}${txHashOrAddress}`;
};
